import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../auth.service';

@Component({
    selector: 'burncase-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    // get
    private _invalidLogin: boolean;

    constructor(private router: Router,
                private authService: AuthService) {
        this._invalidLogin = false;
    }

    get invalidLogin(): boolean {
        return this._invalidLogin;
    }

    ngOnInit() {
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * Checks if user is logged in and redirects him
     */
    public login(pwd: string) {
        if (this.authService.login(pwd)) {
            this.router.navigate(['/burns']);
        } else {
            this.router.navigate(['/']);
            this._invalidLogin = true;
        }

    }

    /**
     * Logs out the user
     */
    public logout() {
        this.authService.logout();
    }

}
